import type {StateCreator} from 'zustand'
import type {LayoutCurrentUser} from '../LayoutStore'

export interface LayoutCurrentUserSlice {
  layoutCurrentUser: LayoutCurrentUser
}

export interface LayoutCurrentUserSliceOpts {
  layoutCurrentUser: LayoutCurrentUser
}

export const createLayoutCurrentUserSlice =
  ({
    layoutCurrentUser,
  }: LayoutCurrentUserSliceOpts): StateCreator<
    LayoutCurrentUserSlice,
    [['zustand/devtools', never]],
    [],
    LayoutCurrentUserSlice
  > =>
  () => ({
    layoutCurrentUser: {
      canComment: layoutCurrentUser.canComment,
    },
  })
